import { Link } from 'react-router-dom';

const articles = [
  {
    path: '/guides/pandabuy-sheet-sneakers-guide',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pair%20of%20trendy%20sneakers%20on%20a%20warm%20cream%20surface%20with%20soft%20morning%20sunlight%20casting%20gentle%20shadows%20editorial%20product%20photography%20clean%20minimalist%20aesthetic%20neutral%20earthy%20tones%20high%20detail%20side%20profile&width=400&height=240&seq=card-sneakers&orientation=landscape',
    icon: 'ri-footprint-line',
    title: 'Sneakers Guide',
    excerpt: 'Best sneaker batches & quality comparison tips from curated pandabuy sheet collections.',
  },
  {
    path: '/guides/pandabuy-sheet-streetwear-guide',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20streetwear%20outfit%20display%20with%20hoodie%20and%20cargo%20pants%20on%20a%20warm%20cream%20backdrop%20soft%20urban%20studio%20lighting%20editorial%20fashion%20photography%20clean%20composition%20neutral%20earthy%20tones&width=400&height=240&seq=card-streetwear&orientation=landscape',
    icon: 'ri-t-shirt-line',
    title: 'Streetwear Picks',
    excerpt: 'Top streetwear essentials from Essentials to Chrome Hearts — ranked and reviewed.',
  },
  {
    path: '/guides/pandabuy-sheet-budget-finds',
    image: 'https://readdy.ai/api/search-image?query=Affordable%20stylish%20fashion%20accessories%20and%20small%20items%20neatly%20arranged%20on%20a%20warm%20cream%20surface%20with%20price%20tags%20soft%20natural%20lighting%20editorial%20product%20photography%20clean%20minimalist%20aesthetic&width=400&height=240&seq=card-budget&orientation=landscape',
    icon: 'ri-price-tag-3-line',
    title: 'Budget Finds',
    excerpt: 'Quality products under $20 — best value across all pandabuy sheet categories.',
  },
  {
    path: '/guides/pandabuy-sheet-accessories-guide',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20collection%20of%20fashion%20accessories%20including%20watch%20belt%20sunglasses%20and%20small%20bag%20on%20a%20warm%20cream%20surface%20soft%20studio%20lighting%20editorial%20product%20photography%20clean%20refined&width=400&height=240&seq=card-accessories&orientation=landscape',
    icon: 'ri-glasses-line',
    title: 'Accessories',
    excerpt: 'Complete guide to bags, belts, jewelry & more from curated spreadsheets.',
  },
  {
    path: '/guides/pandabuy-sheet-quality-tips',
    image: 'https://readdy.ai/api/search-image?query=Closeup%20of%20hands%20inspecting%20product%20quality%20with%20magnifying%20glass%20on%20a%20warm%20cream%20desk%20surface%20soft%20studio%20lighting%20editorial%20photography%20clean%20minimalist%20composition&width=400&height=240&seq=card-quality&orientation=landscape',
    icon: 'ri-sparkling-line',
    title: 'Quality Tips',
    excerpt: 'How to read ratings and spot the best products on any pandabuy sheet.',
  },
  {
    path: '/guides/pandabuy-sheet-vs-competitors',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20with%20organized%20spreadsheet%20data%20on%20one%20side%20and%20scattered%20social%20media%20icons%20on%20the%20other%20warm%20cream%20backdrop%20soft%20studio%20lighting&width=400&height=240&seq=card-vs&orientation=landscape',
    icon: 'ri-scales-3-line',
    title: 'vs Competitors',
    excerpt: 'Pandabuy sheet vs direct browsing, Reddit & TikTok — honest comparison.',
  },
  {
    path: '/guides/pandabuy-sheet-beginner-tips',
    image: 'https://readdy.ai/api/search-image?query=Friendly%20beginner%20shopper%20looking%20at%20laptop%20screen%20with%20organized%20product%20spreadsheet%20displayed%20warm%20cream%20workspace%20soft%20natural%20lighting%20editorial%20photography%20clean%20cozy%20aesthetic&width=400&height=240&seq=card-beginner&orientation=landscape',
    icon: 'ri-user-smile-line',
    title: 'Beginner Tips',
    excerpt: 'New to pandabuy sheet? Start here — step-by-step guide for first-time shoppers.',
  },
  {
    path: '/guides/pandabuy-sheet-trending-products',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20collection%20of%20trendy%20fashion%20products%20and%20accessories%20arranged%20on%20a%20warm%20cream%20surface%20with%20trending%20labels%20soft%20studio%20lighting%20editorial%20photography%20clean%20stylish%20composition&width=400&height=240&seq=card-trending&orientation=landscape',
    icon: 'ri-fire-line',
    title: 'Trending 2026',
    excerpt: 'The most popular pandabuy sheet product discoveries this year — updated weekly.',
  },
  {
    path: '/guides/pandabuy-sheet-safety-guide',
    image: 'https://readdy.ai/api/search-image?query=Secure%20shopping%20concept%20with%20padlock%20shield%20icon%20and%20product%20display%20on%20a%20warm%20cream%20surface%20soft%20studio%20lighting%20editorial%20photography%20clean%20minimalist%20composition%20neutral&width=400&height=240&seq=card-safety&orientation=landscape',
    icon: 'ri-shield-check-line',
    title: 'Safety Guide',
    excerpt: 'Shop smart — essential safety tips and best practices for spreadsheet shopping.',
  },
];

export default function ArticleCTASection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-article-line mr-1"></i> Shopping Guides
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Pandabuy Sheet{' '}
            <span className="italic text-primary-500">Knowledge Base</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl mx-auto">
            Expert guides covering everything from beginner tips to safety advice — all designed to help you get the most from pandabuy sheet collections.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden hover:border-accent-300/50 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  title={`${article.title} — Pandabuy.homes`}
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-5 h-5 flex items-center justify-center text-accent-500">
                    <i className={`${article.icon} text-sm`}></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {article.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-semibold text-accent-600 whitespace-nowrap group-hover:text-accent-700 transition-colors">
                  Read Guide <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Browse Pandabuy Sheet <i className="ri-arrow-right-up-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}